<template>
  <div class="fff">
    <div class="title">{{ $t("device.title") }}</div>
    <div class="system Android" v-if="system == 'Android'">
      <div class="smallTitle">{{ $t("device.about") }}</div>
      <img src="@/assets/img/a.png" />
      <div style="overflow: hidden">
        <div class="system_li">
          <span>{{ $t("device.model") }}</span
          >{{ systems.device_model }}
        </div>
        <div class="system_li">
          <span>{{ $t("device.operator") }}</span
          >{{ systems.operator_name }}
        </div>
        <div class="system_li">
          <span>{{ $t("device.android") }}</span
          >{{ systems.system_version }}
        </div>
        <div class="system_li">
          <span>{{ $t("device.imet") }}</span
          >{{ systems.imei }}
        </div>
        <div class="system_li">
          <span>{{ $t("device.root") }}</span
          >{{ systems.is_root }}
        </div>
        <div class="system_li">
          <span>{{ $t("device.internet") }}</span
          >{{ systems.internet }}
        </div>
        <div class="system_li">
          <span>{{ $t("device.battery") }}</span
          >{{ systems.battery }}
        </div>
        <div class="system_li">
          <span>{{ $t("device.spylix") }}</span
          >{{ systems.name }}
        </div>
        <div class="system_li">
          <span>{{ $t("device.updated") }}</span
          >{{ systems.last_updated }}
        </div>
      </div>
      <div @click="del()" class="loginButton systemButton">
        {{ $t("device.unlink") }}
      </div>
    </div>
    <div class="system" v-if="system == 'iOS'">
      <div class="smallTitle">{{ $t("device.information") }}</div>
      <img src="@/assets/img/i.png" />
      <div style="overflow: hidden">
        <div class="system_li">
          <span>{{ $t("device.myDevice") }}</span
          >{{ systems.device_model }}
        </div>
        <div class="system_li">
          <span>{{ $t("device.spylix") }}</span
          >{{ systems.app_version }}
        </div>
        <div class="system_li">
          <span>{{ $t("device.ios") }}</span
          >{{ systems.system_version }}
        </div>
      </div>
      <div @click="del()" class="loginButton systemButton">
        {{ $t("device.unlink") }}
      </div>
    </div>
    <div class="system" v-if="system == 'iOS'">
      <div class="smallTitle">{{ $t("device.iCloud") }}</div>
      <div style="overflow: hidden">
        <img src="@/assets/img/y.png" />
        <div
          class="system_li"
          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
        >
          <span>{{ $t("device.myDevice") }}</span
          >{{ systems.device_model }}
        </div>
        <div class="system_li">
          <span>{{ $t("device.backup") }}</span>
          <!-- {{ systems.valid_day }} -->
        </div>
        <div class="system_li">
          <span>{{ $t("device.id") }}</span
          >{{ systems.apple_id }}
        </div>
        <div class="system_li">
          <span>{{ $t("device.last") }}</span
          >{{ systems.last_updated }}
        </div>
      </div>
    </div>

    <div class="Popup syy" v-if="isShow">
      <!-- @click="isok = 0" -->
      <div class="Popups_w"></div>
      <div :class="'Popups Popups1'">
        <img src="@/assets/img/x.png" @click="isShow = false" class="close" />
        <div>
          <div class="Popups_title">{{ $t("Confirm Unbinding Device") }}</div>
          <div class="Popups_con">
            {{
              $t(
                "Are you sure you want to unbind the device? All data will be deleted. You’ll need to re-bind to access it again."
              )
            }}
          </div>
          <div class="loginButton PopupsButton" @click="confirm">
            {{ $t("Confirm") }}
          </div>
          <div class="Popups_Button" @click="cancel">
            {{ $t("Cancel") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { indexAccountInfo, EquipmentUnbindDevice } from "@/api/user";
export default {
  inject: ["getheader"],
  name: "HelloWorld",
  data() {
    return {
      system: localStorage.getItem("system"),
      systems: {
        vip_endtime: "",
        name: "",
        is_auto_renewal: 0,
        device_model: "",
        internet: "",
        Android_version: "",
        spy_version: "",
        battery: "",
      },
      msg: "",
      isShow: false,
    };
  },
  mounted() {
    indexAccountInfo({ equipment_id: localStorage.getItem("systemId") }).then(
      (adj) => {
        this.systems = adj.data.vipinfo;
      }
    );
  },
  methods: {
    async confirm() {
      EquipmentUnbindDevice({
        equipment_id: localStorage.getItem("systemId"),
      }).then((adj) => {
        this.getheader();
        setTimeout(() => {
          this.$router.push({ name: "index" });
        }, 300);
      });
    },
    cancel() {
      this.isShow = false;
    },
    del() {
      this.isShow = true;

      // this.$confirm(
      //   this.$t(
      //     "Are you sure you want to unbind the device? All data will be deleted. You’ll need to re-bind to access it again."
      //   ),
      //   this.$t("Confirm Unbinding Device"),
      //   {
      //     distinguishCancelAndClose: true,
      //     confirmButtonText: this.$t("Confirm"),
      //     cancelButtonText: this.$t("Cancel"),
      //   }
      // ).then(() => {

      // });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.smallTitle {
  margin-bottom: 20px;
}

.Popups {
  padding: 0 50px;
}
.Popups1 {
  width: 400px;
  height: 260px;
  margin: -130px -250px;
}

.Popups_title {
  font-size: 16px;
  color: #000927;
  font-weight: 400;
  margin-top: 30px;
  margin-bottom: 20px;
}

.Popups_con {
  font-size: 14px;
  color: grey;
  margin-bottom: 40px;
  font-family: Noto Sans;
}

.Popups_con a {
  color: #0080ff;
}

.PopupsButton {
  width: 180px;
  height: 40px;
  float: left;
  line-height: 40px;
  font-size: 15px;
}

.Popups_Button {
  cursor: pointer;
  width: 176px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  font-size: 15px;
  color: #000927;
  float: left;
  border: 2px solid #00eec3;
  border-radius: 22px;
  margin-left: 40px;
  font-family: Noto Sans;
}
.title {
  font-size: 20px;
  font-weight: 700;
  color: #000927;
  line-height: 100px;
  margin-left: 60px;
}
.system {
  border: 1px solid #e1e3e6;
  border-radius: 12px;
  background: #fff;
  margin-bottom: 20px;
  width: 800px;
  margin-left: 60px;
  overflow: hidden;
  padding-bottom: 40px;
}
.system img {
  float: left;
  width: 40px;
  height: 40px;
  display: block;
  margin-left: 20px;
}
.system_li {
  float: left;
  width: 280px;
  margin-left: 20px;
  font-size: 14px;
  color: #9f9f9f;
  line-height: 20px;
  margin-bottom: 11px;
}
.Android .system_li {
  margin-bottom: 20px;
}
.system_li span {
  float: left;
  color: #3f3f3f;
  /* min-width: 90px; */
  margin-right: 10px;
}
.systemButton {
  float: left;
  width: 220px;
  height: 36px;
  line-height: 36px;
  font-size: 15px;
  margin: 30px 0 0 20px;
}
.fff {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Device.vue